import styled from "styled-components";

export const TryAgainBtn = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  padding: 16px 8px;
  text-align: center;

  width: 25%;
  font-size: 18px;

  border-radius: 12px;
  border: none;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.12);
  color: ${(props) => (!props.disabled ? props.letterColor : "")};
  background: ${(props) => (props.disabled ? "#F3F3F3" : props.bgColor || "#f1b434")};

  @media screen and (max-width: 375px) {
    width: 65%;
    font-size: 16px;
  }

  @media screen and (min-width: 376px) and (max-width: 495px) {
    width: 60%;
    font-size: 16px;
  }

  @media screen and (min-width: 496px) and (max-width: 630px) {
    width: 56%;
    font-size: 17px;
  }

  @media screen and (min-width: 631px) and (max-width: 800px) {
    width: 45%;
    font-size: 18px;
  }

  @media screen and (min-width: 801px) and (max-width: 1000px) {
    width: 48%;
    font-size: 18px;
  }

  @media screen and (min-width: 1001px) and (max-width: 1200px) {
    width: 50%;
    font-size: 18px;
  }

  @media screen and (min-width: 1201px) and (max-width: 1350px) {
    width: 40%;
    font-size: 18px;
  }

  @media screen and (min-width: 1351px) and (max-width: 1500px) {
    width: 40%;
    font-size: 18px;
  }

  @media screen and (min-width: 1501px) and (max-width: 1700px) {
    width: 35%;
    font-size: 18px;
  }
`;